import * as info from "info";
import * as ewe from "@eyeo/webext-ad-filtering-solution";
import { Prefs } from "~/alias/prefs";
import { start as startSettings } from "~/prefs/background";
import { start as startPageviewMetrics } from "../../pageview-metrics/background";
async function bootstrap() {
    if (Prefs.get("data_collection_opt_out")) {
        console.warn("Sentry is not initialized");
    }
    else {
        void ewe.sentry.start(webpackDotenvPlugin.SENTRY_DSN, webpackDotenvPlugin.SENTRY_ENVIRONMENT, info.addonVersion);
    }
    startSettings();
    await startPageviewMetrics();
}
void bootstrap();
